import React, { useState, useRef, useEffect } from 'react';
import {
  MDBInput,
  MDBBtn,
  MDBInputGroup,
  MDBSpinner
} from 'mdb-react-ui-kit';
import emailjs from '@emailjs/browser';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Toast } from 'bootstrap';
import './Contact.css';

export default function App() {
  const [messageToast, setMessageToast] = useState('');
  const [toastSuccess, setToastSuccess] = useState(false);
  const [nameValue, setNameValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [messageValue, setMessageValue] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const toastRef = useRef(null);
  const form = useRef();
  const toastInstance = useRef(null);

  const formRef = useRef();
  const mapRef = useRef();
  const [formVisible, setFormVisible] = useState(false);
  const [mapVisible, setMapVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setFormVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (formRef.current) observer.observe(formRef.current);
    return () => {
      if (formRef.current) observer.unobserve(formRef.current);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setMapVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (mapRef.current) observer.observe(mapRef.current);
    return () => {
      if (mapRef.current) observer.unobserve(mapRef.current);
    };
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);

    if (toastInstance.current) {
      emailjs
        .sendForm('service_p34vc2e', 'template_iiacioq', form.current, 'm70CdSiyxr1i6gVlS')
        .then(
          () => {
            setMessageToast('¡El correo electrónico se ha enviado correctamente!');
            setToastSuccess(true);
            setShowToast(true);
            setNameValue('');
            setEmailValue('');
            setMessageValue('');
          },
          (error) => {
            console.error(error)
            setMessageToast('¡Ha ocurrido un error! ' + error.text);
            setToastSuccess(false);
            setShowToast(true);
          },
        ).finally(() => {
          setIsSending(false);
        });
    } else {
      console.error('Toast instance is null');
    }
  };

  useEffect(() => {
    if (toastRef.current) {
      toastInstance.current = new Toast(toastRef.current);
    }
  }, []);

  useEffect(() => {
    if (showToast && toastInstance.current) {
      toastInstance.current.show();
      setShowToast(false);  // reset the showToast state after showing the toast
    }
  }, [showToast]);

  return (
    <section id="contact" className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 mb-4">
            <div
              ref={formRef}
              className={`form-container h-100 animate-from-left ${formVisible ? 'visible' : ''}`}
            >
              <form ref={form} onSubmit={sendEmail}>
                <h2>Contáctanos</h2>
                <p>Contáctanos a través de correo electrónico.</p>
                <div
                  ref={toastRef}
                  className={`toast align-items-center text-white border-0 mb-4 ${toastSuccess ? 'bg-success' : 'bg-danger'}`}
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                  data-bs-delay="3000"
                >
                  <div className="d-flex">
                    <div className="toast-body">
                      {messageToast}
                    </div>
                    <button
                      type="button"
                      className="btn-close btn-close-white me-2 m-auto"
                      data-bs-dismiss="toast"
                      aria-label="Close"
                    ></button>
                  </div>
                </div>
                <MDBInput
                  name='user_name'
                  value={nameValue}
                  onChange={(e) => setNameValue(e.target.value)}
                  wrapperClass='mb-4'
                  label='Nombre'
                  required
                />
                <MDBInput
                  type='email'
                  name='user_email'
                  value={emailValue}
                  onChange={(e) => setEmailValue(e.target.value)}
                  wrapperClass='mb-4'
                  label='Correo electrónico'
                  required
                />
                <MDBInputGroup className='mb-3' textBefore='Redactar mensaje'>
                  <textarea
                    name="message"
                    value={messageValue}
                    onChange={(e) => setMessageValue(e.target.value)}
                    className='form-control mb-2'
                    required
                  />
                </MDBInputGroup>

                <MDBBtn
                  type="submit"
                  className="mb-4 d-flex align-items-center justify-content-center"
                  style={{ backgroundColor: '#eb6106' }}
                  block
                  disabled={isSending}
                >
                  {isSending ? (
                    <>
                      <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                      Enviando correo...
                    </>
                  ) : (
                    'ENVIAR CORREO'
                  )}
                </MDBBtn>
              </form>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              ref={mapRef}
              className={`map-container h-100 animate-from-right ${mapVisible ? 'visible' : ''}`}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.5053846792152!2d-97.9646921249158!3d20.279337981189016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d08f631f94a711%3A0x8583e9bb3440d6b!2sAztecas%20105%2C%20Col%20Centro%2C%2073080%20Xicotepec%20de%20Ju%C3%A1rez%2C%20Pue.!5e0!3m2!1ses-419!2smx!4v1721257345871!5m2!1ses-419!2smx"
                width="100%"
                height="450"
                style={{ border: 0, borderRadius: 10 }}
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
